// extracted by mini-css-extract-plugin
export default {"greetingPanel":"GreetingPanel_greetingPanel__ldggE","header":"GreetingPanel_header__trrQW","message":"GreetingPanel_message__v30XR"};